import fetchNow from './_Fetch.jsx';

const ApplicationAPI = {
    get: () => {
        return fetchNow('/api/applist', 'GET');
    }
}
 
export default ApplicationAPI;